import { render } from "./ColorLegendVertical.vue?vue&type=template&id=5c524c53&scoped=true"
import script from "./ColorLegendVertical.vue?vue&type=script&lang=js"
export * from "./ColorLegendVertical.vue?vue&type=script&lang=js"

import "./ColorLegendVertical.vue?vue&type=style&index=0&id=5c524c53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c524c53"]])

export default __exports__